var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category"},[_c('router-link',{attrs:{"to":{ name: _vm.r_name, params: { id: _vm.category.id } }}},[_c('div',{staticClass:"category__title"},[_vm._v(_vm._s(_vm.category.title))]),_vm._v(" "),_c('div',{staticClass:"category__count"},[_vm._v("\n      "+_vm._s(_vm.category.count + " " + _vm.companyText)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }